<template>
<div class="interactive-can-callout"  :class="directionClass">
  <div class="interactive-can-callout__text" v-html="text" />
  <div class="interactive-can-callout__line">
    <div class="interactive-can-callout__line__main"/>
    <div class="interactive-can-callout__line__pointer"/>
  </div>
</div>

</template>

<script>
export default {
  name: 'interactive-can-callout',
  props: {
    text: {
      type: String,
      default: 'test callout',
    },
    side: {
      type: String,
      default: 'right',
    }
  },
  data() {
    return {};
  },
  computed: {
    directionClass() {
      return `interactive-can-callout--${this.side}`;
    }
  }
};
</script>

<style lang="scss">
.interactive-can-callout {
  position: absolute;
  right: 100%;
  transform: translateY(-50%);

  &__text {
    @include eyebrow-text;
    letter-spacing: 0;
    color: $color-interactive-can-callout-text;
    margin-bottom: $size-margin-bottom-interactive-can-callout-text;
    padding-right: $size-width-interactive-can-callout-pointer;
    white-space: nowrap;
  }
  &__line {
    width: 100%;
    position: relative;

    &__main,
    &__pointer {
      border-top:
      $size-width-interactive-can-callout-line
      solid
      $color-interactive-can-callout-line;
      position: absolute;
      top: 0;
    }
    &__main {
      left: 0;
      right: $size-width-interactive-can-callout-pointer;
    }

    &__pointer {
      transform: rotate(45deg);
      transform-origin: left top;
      right: 0;
      width: $size-width-interactive-can-callout-pointer;
    }
  }

  &--right.interactive-can-callout {
    right: initial;
    left: 100%;

    .interactive-can-callout {

      &__text {
        padding-right: 0;
        padding-left: $size-width-interactive-can-callout-pointer;
      }

      &__line {
        &__main {
          right: 0;
          left: $size-width-interactive-can-callout-pointer;
        }

        &__pointer {
          transform: rotate(-45deg);
          transform-origin: right top;
          right: initial;
          left: 0;
        }
      }
    }
  }
}
</style>
